<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'用户管理'},{name:'用户列表',goback:true},{name:'用户明细'}]" :title="'用户明细'"/>
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="用户明细" name="1"></el-tab-pane>
              <el-tab-pane label="用户统计" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box" v-show="tab ==='1'">
                <div class="basic">
                <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号：</div>
                        <div class="content">{{detail.userName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">绑定手机号：</div>
                        <div class="content">{{detail.phone}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号来源：</div>
                        <div class="content">{{detail.sourceName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">客户经理：</div>
                        <div class="content">{{detail.customerManager}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">姓名：</div>
                        <div class="content">{{detail.realName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">邮箱：</div>
                        <div class="content">{{detail.email}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系地址：</div>
                        <div class="content">{{detail.contactAddress}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">企业全称：</div>
                        <div class="content">{{detail.companyName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">统一社会信用代码：</div>
                        <div class="content">{{detail.companyNum}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">用户类型：</div>
                        <div class="content">{{detail.userTypeName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='CORPORATE_CLIENTS' || detail.userType=='BANK' || detail.userType=='INSTITUTIONAL_INVESTOR' || detail.userType=='GOVERNMENT_DEPARTMENT' || detail.userType=='INCUBATOR' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'"> 
                        <div class="name">联系人：</div>
                        <div class="content">{{detail.contact}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='CORPORATE_CLIENTS' || detail.userType=='BANK' || detail.userType=='INSTITUTIONAL_INVESTOR'  || detail.userType=='GOVERNMENT_DEPARTMENT' || detail.userType=='INCUBATOR' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                        <div class="name">联系手机号：</div>
                        <div class="content">{{detail.contactPhone}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='CORPORATE_CLIENTS' || detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                        <div class="name">营业执照：</div>
                        <div class="content"><img class="license" :src="detail.frontPath+detail.attachmentUrl"></div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='INSTITUTIONAL_INVESTOR'">
                        <div class="name">名片：</div>
                        <div class="content"><img :src="detail.logoUrl"></div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='BANK'">
                        <div class="name">LOGO：</div>
                        <div class="content"><img style="height: 140px;width: 140px;" :src="detail.frontPath+detail.logoUrl"></div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='BANK'">
                        <div class="name">银行名称（简称）：</div>
                        <div class="content">{{detail.abbreviation}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='BANK'">
                        <div class="name">官网链接：</div>
                        <div class="content">{{detail.websiteLink}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='BANK'">
                        <div class="name">简介：</div>
                        <div class="content">{{detail.remarks}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="detail.userType=='FINANCE_LEASING_COMPANY' || detail.userType=='GUARANTEE_COMPANY'">
                        <div class="name">公司简介：</div>
                        <div class="content">{{detail.remarks}}</div>
                    </div>
                  </el-col>
                  
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <div class="basisTitle">其他信息</div>
                    <div class="child mt10">
                        <div class="name">创建时间：</div>
                        <div class="content">{{detail.createTime}}</div>
                    </div>  
                  </el-col>
                </el-row>
                
                    <!-- <div class="child" v-if="detail.userType=='GOVERNMENT_DEPARTMENT'">
                        <div class="name">平台认证函：</div>
                        <div class="content"><img :src="detail.frontPath+detail.logoUrl"></div>
                    </div> -->                  
                    
                </div>
            </div>
            <!-- 用户统计 -->
            <div class="box" v-show="tab==='2'">
                <div class="statistics">
                    <div class="staTitle">债权产品统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">上架中</div>
                            <div class="num">{{debtStatistics.shelfDebtNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">已下架</div>
                            <div class="num">{{debtStatistics.obtainedDebtNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">发布产品</div>
                            <div class="num">{{debtStatistics.releaseDebtNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{debtStatistics.underReviewDebtNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{debtStatistics.throughDebtNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{debtStatistics.didNotPassDebtNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">申请贷款统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">申请贷款</div>
                            <div class="num">{{debtStatistics.applyNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{debtStatistics.applyUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{debtStatistics.applyThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{debtStatistics.applyDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">申请贷款发放统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">处理中</div>
                            <div class="num">{{debtStatistics.applyProcessingNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">贷款失败</div>
                            <div class="num">{{debtStatistics.applyLoanFailureNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">发放成功</div>
                            <div class="num">{{debtStatistics.applySuccessfullyIssuedNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">放款金额</div>
                            <div class="num">{{debtStatistics.loanAmount||'0'}}<span>元</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">申请融资租赁统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">申请融资租赁</div>
                            <div class="num">{{financialLeasingStatistics.applyNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{financialLeasingStatistics.applyUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{financialLeasingStatistics.applyThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{financialLeasingStatistics.applyDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle"> 融资租赁申请结果统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">处理中</div>
                            <div class="num">{{financialLeasingStatistics.applyProcessingNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">申请失败</div>
                            <div class="num">{{financialLeasingStatistics.applyFailureNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">申请成功</div>
                            <div class="num">{{financialLeasingStatistics.applySuccessfullyNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">发布股权融资项目统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">上架中</div>
                            <div class="num">{{equityStatistics.shelfNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">已下架</div>
                            <div class="num">{{equityStatistics.obtainedNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">发布项目</div>
                            <div class="num">{{equityStatistics.releaseNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{equityStatistics.underReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{equityStatistics.throughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{equityStatistics.didNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">约谈</div>
                            <div class="num">{{equityStatistics.interviewNumber||'0'}}<span>次</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">担保申请统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">申请担保</div>
                            <div class="num">{{vouchStatistics.applyNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{vouchStatistics.applyUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{vouchStatistics.applyThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{vouchStatistics.applyDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">申请担保的担保进度统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">放款金额</div>
                            <div class="num">{{vouchStatistics.loanAmount||'0'}}<span>元</span></div>
                        </li>
                        <li>
                            <div class="name">保后管理</div>
                            <div class="num">{{vouchStatistics.applyGuaranteeRearNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">银行放款</div>
                            <div class="num">{{vouchStatistics.applyBankLendingNumber	||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">签订协议</div>
                            <div class="num">{{vouchStatistics.applySignProtocolNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">银行上会审批</div>
                            <div class="num">{{vouchStatistics.applyBankApprovalNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">担保上会审批</div>
                            <div class="num">{{vouchStatistics.applyVouchApprovalNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">尽职调查</div>
                            <div class="num">{{vouchStatistics.applySurveyNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">担保公司受理</div>
                            <div class="num">{{vouchStatistics.applyAcceptNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">担保失败</div>
                            <div class="num">{{vouchStatistics.applyVouchFailNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">发布政策资讯统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">上架中</div>
                            <div class="num">{{policyGuidanceStatistics.policyInfoShelfNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">已下架</div>
                            <div class="num">{{policyGuidanceStatistics.policyInfoObtainedNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">发布政策资讯数</div>
                            <div class="num">{{policyGuidanceStatistics.policyInfoReleaseNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{policyGuidanceStatistics.policyInfoUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{policyGuidanceStatistics.policyInfoThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{policyGuidanceStatistics.policyInfoDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">发布政策申报统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">上架中</div>
                            <div class="num">{{policyGuidanceStatistics.policyDeclareShelfNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">已下架</div>
                            <div class="num">{{policyGuidanceStatistics.policyDeclareObtainedNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">发布政策申报数</div>
                            <div class="num">{{policyGuidanceStatistics.policyDeclareReleaseNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{policyGuidanceStatistics.policyDeclareUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{policyGuidanceStatistics.policyDeclareThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{policyGuidanceStatistics.policyDeclareDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">申请政策申报统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">申请政策申报数</div>
                            <div class="num">{{policyGuidanceStatistics.applyNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{policyGuidanceStatistics.applyUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{policyGuidanceStatistics.applyThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{policyGuidanceStatistics.applyDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">发布孵化器统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">上架中</div>
                            <div class="num">{{incubatorStatistics.incubatorShelfNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">已下架</div>
                            <div class="num">{{incubatorStatistics.incubatorObtainedNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">场地数</div>
                            <div class="num">{{incubatorStatistics.incubatorSiteNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">发布孵化器数</div>
                            <div class="num">{{incubatorStatistics.incubatorReleaseNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{incubatorStatistics.incubatorUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{incubatorStatistics.incubatorThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{incubatorStatistics.incubatorDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">申请入驻孵化器统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">申请入驻孵化器数</div>
                            <div class="num">{{incubatorStatistics.applyIncubatorNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{incubatorStatistics.applyIncubatorUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{incubatorStatistics.applyIncubatorThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{incubatorStatistics.applyIncubatorDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
                <div class="statistics">
                    <div class="staTitle">活动报名统计</div>
                    <el-divider direction="vertical"></el-divider>
                    <ul>
                        <li>
                            <div class="name">活动报名数</div>
                            <div class="num">{{activitySalonStatistics.applyActivitySalonNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核中</div>
                            <div class="num">{{activitySalonStatistics.applyActivitySalonUnderReviewNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核通过</div>
                            <div class="num">{{activitySalonStatistics.applyActivitySalonThroughNumber||'0'}}<span>个</span></div>
                        </li>
                        <li>
                            <div class="name">审核未通过</div>
                            <div class="num">{{activitySalonStatistics.applyActivitySalonDidNotPassNumber||'0'}}<span>个</span></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{},//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
        }
    },
    methods:{
        // 切换选项卡
        changeTab:function(tab){
            this.tab=tab.name;
			      this.getData();
        },
        //获取数据
        getData:function(){
			if(this.tab==='1'){
				this.$axiosz.get('backstage/sysUser/manage/'+this.id).then((r)=>{
				    if(r.code==200){
				        this.detail=r.data;
				    }else{
				        this.$alert(r.msg)
				    }
				})
			}else{
				this.$axiosc.get('backstage/common/user/statistics/'+this.id).then((r)=>{
				    if(r.code==200){
						let data=r.data;
						if(data){
							this.debtStatistics=data.debtStatistics;//债权融资统计
							this.financialLeasingStatistics=data.financialLeasingStatistics;//融资租赁统计
							this.equityStatistics=data.equityStatistics;//股权融资列表统计
							this.vouchStatistics=data.vouchStatistics;//担保服务统计
							this.policyGuidanceStatistics=data.policyGuidanceStatistics;//政策指引统计
							this.incubatorStatistics=data.incubatorStatistics;//孵化器统计
							this.activitySalonStatistics=data.activitySalonStatistics;//活动沙龙统计
						}
				    }else{
				        this.$alert(r.msg)
				    }
				})
			}
            
        }
    },
    created(){
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 40px);
    overflow: hidden;
}
.box{
    padding-top:20px;
    height:calc(94% - 85px);
    overflow-x: hidden;
    overflow-y: auto;
    
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  background: #fff;
  .el-col{
    margin: 10px 0;
  }
}
</style>